import React from "react";

const PatientTracking = ({ trackingData, onChange }) => {
  const options = [
    { label: "Meal Confirmation", key: "mealConfirmation" },
    { label: "Image Upload Required", key: "imageUploadRequired" },
    { label: "Reminder Notification", key: "reminderNotification" },
  ];

  return (
    <div className="bg-emerald-50 border border-emerald-100 rounded-xl p-4">
      <h3 className="font-semibold mb-4 text-emerald-800 flex items-center gap-2">
        <span className="w-2 h-4 bg-emerald-500 rounded-full"></span>
        Patient Tracking & Compliance
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {options.map((option) => (
          <div key={option.key}>
            <label className="text-xs font-bold text-gray-700 block mb-3">
              {option.label}
            </label>

            <div className="flex gap-8">
              <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer group">
                <div className="relative flex items-center">
                  <input
                    type="radio"
                    name={option.key}
                    checked={trackingData[option.key] === 1}
                    onChange={() => onChange(option.key, 1)}
                    className="sr-only"
                  />
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all ${trackingData[option.key] === 1 ? 'border-brand-primaryColor bg-brand-primaryColor' : 'border-gray-300'}`}>
                    {trackingData[option.key] === 1 && <div className="w-2 h-2 bg-white rounded-full"></div>}
                  </div>
                </div>
                <span className="font-medium">Yes</span>
              </label>

              <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer group">
                <div className="relative flex items-center">
                  <input
                    type="radio"
                    name={option.key}
                    checked={trackingData[option.key] === 0}
                    onChange={() => onChange(option.key, 0)}
                    className="sr-only"
                  />
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all ${trackingData[option.key] === 0 ? 'border-brand-primaryColor bg-brand-primaryColor' : 'border-gray-300'}`}>
                    {trackingData[option.key] === 0 && <div className="w-2 h-2 bg-white rounded-full"></div>}
                  </div>
                </div>
                <span className="font-medium">No</span>
              </label>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PatientTracking;
